import dialog from '@/components/Modal/dialog'
import React, { useRef } from 'react'
import TransferContent from '@/components/Transfer'
import { useLocale } from 'core/components/Locale'
import { useAuthenticate } from 'core/components/Authenticate'
import { useHCRouter } from '@/components/HCNextLink'
import notification from '@/components/notification'

type TOptions = {
  onSuccess?: (res: any, target: string) => void
}

export const useTransfer = (options?: TOptions) => {
  const transferRef = useRef(null)
  const t = useLocale()
  const auth = useAuthenticate()
  const router = useHCRouter()

  const executeTransfer = (resolve: Function, subResolve: Function, reject: Function, subReject: Function) => {
    if (!transferRef.current) return
    const result = transferRef.current.onTransfer()
    if (!result) return
    const source = transferRef.current.source
    const target = transferRef.current.target
    result.then((response: any) => {
      const res = response.data
      switch (Number(res.code)) {
        case 200:
          notification.success({
            message: res?.msg,
          })
          options?.onSuccess?.(res, target)
          resolve(res)
          subResolve(res)
          break
        case 20351: // 需要审核
          options?.onSuccess?.(res)
          resolve(res)
          subResolve(res)
          dialog({
            title: t('accountCoinTrade_109') as string,
            content: <div>{t('accountCoinTrade_148')}</div>,
            showCancel: true,
            cancelText: t('accountCoinTrade_140') as string,
            confirmText: t('accountCoinTrade_149') as string,
            onConfirm: () => {
              router.push(`/orderHome/transferRecord?source=${source}&target=${target}`)
            },
          })
          break
        case 30303: // 临时黑名单
        case 30304: // 永久黑名单
          notification.error({
            message: res?.msg,
          })
          dialog({
            title: t('accountCoinTrade_109') as string,
            content: <div>{t(res.code === 30303 ? 'accountCoinTrade_150' : 'accountCoinTrade_151')}</div>,
            showCancel: true,
            cancelText: t('accountCoinTrade_140') as string,
            confirmText: t('accountCoinTrade_152') as string,
            onConfirm: () => {
              // TODO 联系客服
            },
          })
          break
        case 30705: // 划转数量超过最大可划转数量
          reject(res)
          subReject(res)
          notification.error({
            message: res?.msg,
          })
          break
        default:
          notification.error({
            message: res?.msg,
          })
      }
    })
  }

  return async (config) => {
    return await new Promise((resolve, reject) => {
      if (!auth.loginData) {
        router.push('/login')
        return
      }
      dialog({
        title: t('contractAssets_016') as string,
        cancelText: t('contractOrder_101') as string,
        confirmText: t('contractAssets_017') as string,
        showClose: true,
        width: 520,
        showCancel: true,
        content: ({ close }) => <TransferContent ref={transferRef} onClose={close} {...config} />,
        onConfirm: () => {
          return new Promise((subResolve, subReject) => {
            if (transferRef?.current) {
              if (transferRef?.current?.walletInfo?.transferOpenCardInvalid) {
                dialog({
                  showCancel: false,
                  showClose: true,
                  width: 506,
                  confirmText: t('hotcoinWeb_v1_22_250_StillNeedToTransfer'),
                  title: t('hotcoinWeb_v1_22_250_TransferringFundsOutOf'),
                  content: <div>{t('hotcoinWeb_v1_22_250_TransferringOutWillCause')}</div>,
                  onConfirm: () => {
                    return executeTransfer(resolve, subResolve, reject, subReject)
                  },
                })
              } else {
                executeTransfer(resolve, subResolve, reject, subReject)
              }
            }
          })
        },
      })
    })
  }
}
